module.exports = "/wp-content/themes/conversion/public/dist//svgs/arrow_drop_down.svg";